import React from 'react'
import { Box, Container, Flex, Image, Text, Heading } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import skillsArr from './skillsArr.js'
import '../css/Skills.css'

export default function Skills() {

  return (
    <Box id='skills' p={10}>
      <Container maxW='container.lg' pt={14} pb={16}>
        <Heading as='h2' size='lg' noOfLines={1} pb={10}>Skills & Tools</Heading>

          <Flex
          textAlign='center'
          justifyContent='center'
          alignItems='center'
          gap='20'
          flexDirection='row'
          flexWrap='wrap'
          >
              {skillsArr?.map(skill => {
                return (
                  <motion.div
                    whileInView={{opacity: [0, 1]}}
                    transition={{ duration: 0.5}}
                    key={skill.id}
                  >                  
                   <Box>
                      <Image
                        boxSize='3.8rem'
                        objectFit='contain'
                        src={skill.logo} 
                        alt={skill.name} />
                    </Box>
                    <Text pt={4} fontSize='sm' fontWeight='bold' >{skill.name}</Text>   
                  </motion.div>
                )
              })}    
          </Flex>

          <motion.div
            whileInView={{opacity: [0, 1]}}
            transition={{ duration: 0.5}}
          >
            <Heading as='h3' size='md' noOfLines={1} pt={20}>Currently working on:</Heading>
            <Container pt={8} maxW='container.sm' centerContent>
              <Text fontSize='lg'>
              I recently started a 13-week course on UX/UI, an area that I feel will help me build interactive and accessible websites and products. In addition, I have been working and experimenting with 3D modeling and different tools, such as Spline and Three.js.
              </Text>
            </Container>            
          </motion.div>

      </Container>
    </Box>
  )
}
